import React from 'react';

import EmojiRocket from '../../assets/emoji_rocket.webp';

import Header from '../../components/header';
import LandingProcess from './process';
import LandingFeatures from './features';
import LandingPricing from './pricing';
import LandingFaqs from './faq';
import LandingContact from './contact';
import LandingValueProposition from './value_proposition';
import Footer from '../../components/footer';
import { Link } from 'react-router-dom';

class Landing extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      model: '',
    };
  }

  componentDidMount() {
    this.renderAssets();
    window.addEventListener('scroll', this.loadModel, { passive: true });
    setTimeout(this.loadModel, 3000);
  }

  loadModel = () => {
    this.setState({
      model: '/itoki_chair.glb',
    });
    window.removeEventListener('scroll', this.loadModel, { passive: true });
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.loadModel, { passive: true });
  }

  renderAssets = () => {
    const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));

    if ('IntersectionObserver' in window) {
      const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                videoSource.src = videoSource.dataset.src;
              }
            }

            video.target.load();
            video.target.classList.remove('lazy');
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });

      lazyVideos.forEach(function (lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  };

  render() {
    return (
      <>
        <Header showNav />
        <div id="landing-banner">
          <div id="landing-banner-inner">
            <div id="landing-banner-bg" />
            <div id="landing-banner-content" className="landing-width-limit">
              <div id="landing-banner-text">
                <h1>Bring your products to life</h1>
                <p>Add 3D/AR to your site with zero effort</p>
                <Link to="/register" id="landing-banner-btn">
                  <img src={EmojiRocket} alt="" id="landing-banner-btn-icon" />
                  Get Started
                </Link>
              </div>
              <model-viewer
                id="landing-banner-viewer"
                src={this.state.model}
                environment="neutral"
                poster="/itoki_chair_poster.webp"
                environment-image="neutral"
                camera-orbit="311.8deg 68.43deg auto"
                auto-rotate={true}
                auto-rotate-delay={0}
                interaction-prompt="none"
                seamless-poster
                disable-zoom
                disable-pan
                shadow-intensity="1"
                camera-controls>
                <div slot="progress-bar" />
                <div slot="ar-button" />
              </model-viewer>
            </div>
          </div>
        </div>
        <LandingValueProposition />
        <div className="landing-section" id="process">
          <h2 className="landing-section-heading">Our Process</h2>
          <LandingProcess />
        </div>
        <div className="landing-section" id="features">
          <h2 className="landing-section-heading">Features</h2>
          <LandingFeatures />
        </div>
        <div className="landing-section" id="pricing">
          <h2 className="landing-section-heading">Pricing</h2>
          <LandingPricing />
        </div>
        <div className="landing-section" id="contact">
          <h2 className="landing-section-heading">Contact Us</h2>
          <LandingContact />
        </div>
        <div className="landing-section" id="faq">
          <h2 className="landing-section-heading">Frequently asked questions</h2>
          <LandingFaqs />
        </div>
        <Footer />
      </>
    );
  }
}

export default Landing;
